"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SESSION_STORAGE_KEY_PREFIX = void 0;
const SESSION_STORAGE_KEY_PREFIX = exports.SESSION_STORAGE_KEY_PREFIX = 'ori-personal-menu-cache';